if (!customElements.get('byte-image-gallery-slider')) {
  class ByteImageGallerySlider extends HTMLElement {
    constructor() {
      super();

      this.swiperInstance = null;
      this.boundHandleSectionLoad = this.handleSectionLoad.bind(this);
      this.boundHandleDomReady = this.handleDomReady.bind(this);
    }

    connectedCallback() {
      this.#cacheElements();
      this.#bindEvents();
      this.#scheduleInit();
    }

    disconnectedCallback() {
      this.#unbindEvents();
      this.#destroySwiper();
    }

    handleSectionLoad(event) {
      if (!event.target.contains(this)) return;

      this.#destroySwiper();
      this.#initSwiper();
    }

    handleDomReady() {
      this.#initSwiper();
    }

    #cacheElements() {
      this.swiperContainer = this.querySelector('[data-gallery-swiper]');
      this.prevButton = this.querySelector('[data-gallery-prev]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.paginationContainer = this.querySelector('[data-gallery-pagination]');
    }

    #bindEvents() {
      if (!window.Shopify?.designMode) return;

      document.addEventListener('shopify:section:load', this.boundHandleSectionLoad);
    }

    #unbindEvents() {
      document.removeEventListener('shopify:section:load', this.boundHandleSectionLoad);
      document.removeEventListener('DOMContentLoaded', this.boundHandleDomReady);
    }

    #scheduleInit() {
      /*
       * The Swiper vendor bundle may be declared after this component's own
       * script tag in the document, so `Swiper` can still be undefined the
       * moment this deferred script runs. Waiting for DOMContentLoaded
       * guarantees every deferred script (including the vendor bundle) has
       * already executed, regardless of tag order in theme.liquid.
       */
      if (document.readyState === 'complete') {
        this.#initSwiper();
        return;
      }

      document.addEventListener('DOMContentLoaded', this.boundHandleDomReady, { once: true });
    }

    #initSwiper() {
      if (!this.swiperContainer) return;

      if (typeof Swiper === 'undefined') {
        console.error('Swiper library not found. Load vendor-swiper-bundle before byte-image-gallery-slider.js.');
        return;
      }

      const slidesPerViewDesktop = Number(this.dataset.slidesPerView) || 4;
      const shouldAutoplay = this.dataset.autoplay === 'true';
      const autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;

      this.swiperInstance = new Swiper(this.swiperContainer, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          prevEl: this.prevButton,
          nextEl: this.nextButton
        },
        pagination: {
          el: this.paginationContainer,
          clickable: true
        },
        on: {
          lock: () => this.classList.add('is-locked'),
          unlock: () => this.classList.remove('is-locked')
        },
        autoplay: shouldAutoplay ? { delay: autoplaySpeed, disableOnInteraction: false } : false,
        breakpoints: {
          750: {
            slidesPerView: 2.2
          },
          990: {
            slidesPerView: slidesPerViewDesktop
          }
        }
      });

      this.classList.toggle('is-locked', this.swiperInstance.isLocked);
    }

    #destroySwiper() {
      if (!this.swiperInstance) return;

      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  customElements.define('byte-image-gallery-slider', ByteImageGallerySlider);
}